import { useCallback, useState } from 'react';
import { getPosPackageExpansion } from '../../api/packages';
import { useSalesStore } from './sales-store';

/**
 * POS csomag-eladás kosár-hook (Q-T043).
 *
 * A SALES-csomag kiválasztásakor lekéri a BE pos-expansion-t (`GET
 * /packages/:id/pos-expansion` — 1 billing-sor + N készlet-tétel) és a store
 * `addPackageToCart`-ján keresztül 1 kosársorként beteszi (csomag-ár). A készlet
 * tételenkénti csökkentése a sale-write atomi tranzakciója (BE — Q-T044), nem FE-gond.
 */
export function useAddPosPackageToCart(): {
  addPackage: (packageId: string) => Promise<void>;
  isLoading: boolean;
  error: string | null;
} {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const addPackageToCart = useSalesStore(s => s.addPackageToCart);

  const addPackage = useCallback(
    async (packageId: string) => {
      setIsLoading(true);
      setError(null);
      try {
        const { data } = await getPosPackageExpansion(packageId);
        addPackageToCart(data);
      } catch (err) {
        const message = err instanceof Error ? err.message : 'Failed to add package to cart';
        setError(message);
        throw err;
      } finally {
        setIsLoading(false);
      }
    },
    [addPackageToCart]
  );

  return { addPackage, isLoading, error };
}
